import isStatusUnconfirmed from '../isStatusUnconfirmed';
import { pipe, prop } from '../../utils';

const isOrderUnconfirmed = pipe(
  prop('status'),
  isStatusUnconfirmed,
);

export default isOrderUnconfirmed;
